import { find as findLinks } from 'linkifyjs';
import type { NoteMention } from './types';
function plainText(text: string, offset: number) {
  const parts = [];
  let cursor = 0;
  for (const link of findLinks(text)) {
    if (!/^(https?:|mailto:)/i.test(link.href)) continue;
    parts.push(text.slice(cursor, link.start));
    parts.push(
      <a
        key={`link-${offset + link.start}`}
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-700 underline dark:text-blue-300"
      >
        {text.slice(link.start, link.end)}
      </a>,
    );
    cursor = link.end;
  }
  parts.push(text.slice(cursor));
  return parts;
}
export function NoteText({
  text = '',
  mentions = [],
  team = false,
}: {
  text: string;
  mentions?: NoteMention[];
  team?: boolean;
}) {
  let offset = 0;
  const parts = [];
  for (const mention of [...(mentions || [])].sort((a, b) => a.start - b.start)) {
    if (mention.start < offset || text.slice(mention.start, mention.end) !== `@${mention.name}`)
      continue;
    parts.push(...plainText(text.slice(offset, mention.start), offset));
    parts.push(
      <strong
        key={`${mention.start}-${mention._user}`}
        className={
          team
            ? 'font-bold text-violet-700 dark:text-violet-300'
            : 'font-bold text-blue-700 dark:text-blue-300'
        }
      >
        {text.slice(mention.start, mention.end)}
      </strong>,
    );
    offset = mention.end;
  }
  parts.push(...plainText(text.slice(offset), offset));
  return <span className="whitespace-pre-wrap break-words">{parts}</span>;
}
